export default __webpack_public_path__ + "images/ru-f1c2ba49b3ccc06ba58a3889e1445971.svg";